<template>
  <div class="system-dic-dialog-container">
    <el-dialog :title="title" :visible.sync="isShowDialog" width="1100px">
      <el-form
        ref="dicDialogFormRef"
        :model="formData"
        v-loading="isLoading"
        :rules="rules"
        size="small"
        label-width="90px"
        class="demo-ruleForm"
      >
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="项目名" prop="TalentName">
              <el-input
                v-model="formData.TalentName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="唯一标识" prop="TalentCode">
              <el-input
                v-model="formData.TalentCode"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
            <el-form-item label="表单类型" prop="Type">
              <el-select
                v-model="formData.Type"
                @change="selectChange"
                filterable
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in dicList"
                  :key="item.ItemValue"
                  :label="item.ItemText"
                  :value="item.ItemValue"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="mb20">
                <el-form-item label="权重比值" prop="Weight">
                  <el-select
                    filterable
                    multiple
                    v-model="formData.Weight"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in quanzhongList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
          <el-col
            :xs="24"
            :sm="24"
            :md="24"
            :lg="24"
            :xl="24"
            class="mb20"
            v-if="formData.Type == 1"
          >
            <el-form-item label="下拉数据" prop="">
              <vxe-table
                border
                resizable
                show-overflow
                :data="tableData"
                align="center"
                :edit-rules="validRules"
                :edit-config="{ trigger: 'click', mode: 'cell' }"
              >
                <!-- <vxe-column type="seq" width="60"></vxe-column> -->
                <vxe-column
                  field="Text"
                  title="选项名"
                  :edit-render="{ autofocus: '.vxe-input--inner' }"
                >
                  <template #edit="{ row }">
                    <vxe-input v-model="row.Text" type="text"></vxe-input>
                  </template>
                </vxe-column>
                <vxe-column
                  field="Value"
                  title="唯一标识"
                  :edit-render="{}"
                  width="110"
                >
                  <template #edit="{ row }">
                    <vxe-input
                      min="0"
                      v-model="row.Value"
                      type="number"
                      placeholder="请输入唯一标识"
                    ></vxe-input>
                  </template>
                </vxe-column>
                <!-- <vxe-column
                      field="Score"
                      title="得分"
                      :edit-render="{}"
                      width="100"
                    >
                      <template #edit="{ row }">
                        <vxe-input
                          min="0"
                          v-model="row.Score"
                          type="number"
                          placeholder="请输入数值"
                        ></vxe-input>
                      </template>
                    </vxe-column> -->

                <vxe-column field="Remark" title="备注" :edit-render="{}">
                  <template #edit="{ row }">
                    <vxe-input
                      v-model="row.Remark"
                      type="text"
                      placeholder="请输入备注"
                    ></vxe-input>
                  </template>
                </vxe-column>
                <vxe-column title="操作" width="100" show-overflow>
                  <template #default="{ row, rowIndex }">
                    <vxe-button
                      mode="text"
                      icon="vxe-icon-add"
                      @click="addRow(row)"
                    ></vxe-button>
                    <vxe-button
                      mode="text"
                      icon="vxe-icon-delete"
                      v-if="rowIndex > 0"
                      @click="delRow(row, rowIndex)"
                    ></vxe-button>
                  </template>
                </vxe-column>
              </vxe-table>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="onCancel" size="default">取 消</el-button>
          <el-button
            :loading="btnLoading"
            type="primary"
            @click="onSubmit"
            size="default"
            >保存</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetTalentTaletnDatil,
  AddTalentDic,
  UpdateTalentDic,
} from "@/api/talentIdentification/talentIdentification";

import { Editor, Toolbar } from "@wangeditor/editor-for-vue";

export default {
  components: { Editor, Toolbar },
  props: {
    dicList: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      editor: null,
      key: "edit",
      title: "编辑",
      isShowDialog: false,
      isLoading: false,
      btnLoading: false,
      formData: {},
      rules: {
        TalentName: [
          { required: true, message: "请输入项目名", trigger: "blur" },
        ],
        TalentCode: [
          { required: true, message: "请输入唯一标识", trigger: "blur" },
        ],
        Type: [
          { required: true, message: "请选择表单类型", trigger: "change" },
        ],
      },
      tableData: [],
      tableData_backup: [],
      validRules: {
        Text: [{ required: true, message: "请输入选项名" }],
        Value: [{ required: true, message: "请输入选项唯一标识" }],
        // Score: [{ required: true, message: "请输入得分" }],
      },
      quanzhongList: [
        {
          id: 1,
          label: "1%",
          value: 0.01,
        },
        {
          id: 2,
          label: "2%",
          value: 0.02,
        },
        {
          id: 3,
          label: "3%",
          value: 0.03,
        },
        {
          id: 4,
          label: "4%",
          value: 0.04,
        },
        {
          id: 5,
          label: "5%",
          value: 0.05,
        },
        {
          id: 6,
          label: "6%",
          value: 0.06,
        },
        {
          id: 7,
          label: "7%",
          value: 0.07,
        },
        {
          id: 8,
          label: "8%",
          value: 0.08,
        },
        {
          id: 9,
          label: "9%",
          value: 0.09,
        },
        {
          id: 10,
          label: "10%",
          value: 0.1,
        },
        {
          id: 11,
          label: "11%",
          value: 0.11,
        },
        {
          id: 12,
          label: "12%",
          value: 0.12,
        },
        {
          id: 13,
          label: "13%",
          value: 0.13,
        },
        {
          id: 14,
          label: "14%",
          value: 0.14,
        },
        {
          id: 15,
          label: "15%",
          value: 0.15,
        },
        {
          id: 16,
          label: "16%",
          value: 0.16,
        },
        {
          id: 17,
          label: "17%",
          value: 0.17,
        },
        {
          id: 18,
          label: "18%",
          value: 0.18,
        },
        {
          id: 19,
          label: "19%",
          value: 0.19,
        },
        {
          id: 20,
          label: "20%",
          value: 0.2,
        },
        {
          id: 21,
          label: "21%",
          value: 0.21,
        },
        {
          id: 22,
          label: "22%",
          value: 0.22,
        },
        {
          id: 23,
          label: "23%",
          value: 0.23,
        },
        {
          id: 24,
          label: "24%",
          value: 0.24,
        },
        {
          id: 25,
          label: "25%",
          value: 0.25,
        },
        {
          id: 26,
          label: "26%",
          value: 0.26,
        },
        {
          id: 27,
          label: "27%",
          value: 0.27,
        },
        {
          id: 28,
          label: "28%",
          value: 0.28,
        },
        {
          id: 29,
          label: "29%",
          value: 0.29,
        },
        {
          id: 30,
          label: "30%",
          value: 0.3,
        },
        {
          id: 31,
          label: "31%",
          value: 0.31,
        },
        {
          id: 32,
          label: "32%",
          value: 0.32,
        },
        {
          id: 33,
          label: "33%",
          value: 0.33,
        },
        {
          id: 34,
          label: "34%",
          value: 0.34,
        },
        {
          id: 35,
          label: "35%",
          value: 0.35,
        },
        {
          id: 36,
          label: "36%",
          value: 0.36,
        },
        {
          id: 37,
          label: "37%",
          value: 0.37,
        },
        {
          id: 38,
          label: "38%",
          value: 0.38,
        },
        {
          id: 39,
          label: "39%",
          value: 0.39,
        },
        {
          id: 40,
          label: "40%",
          value: 0.4,
        },
        {
          id: 41,
          label: "41%",
          value: 0.41,
        },
        {
          id: 42,
          label: "42%",
          value: 0.42,
        },
        {
          id: 43,
          label: "43%",
          value: 0.43,
        },
        {
          id: 44,
          label: "44%",
          value: 0.44,
        },
        {
          id: 45,
          label: "45%",
          value: 0.45,
        },
        {
          id: 46,
          label: "46%",
          value: 0.46,
        },
        {
          id: 47,
          label: "47%",
          value: 0.47,
        },
        {
          id: 48,
          label: "48%",
          value: 0.48,
        },
        {
          id: 49,
          label: "49%",
          value: 0.49,
        },
        {
          id: 50,
          label: "50%",
          value: 0.5,
        },
        {
          id: 51,
          label: "51%",
          value: 0.51,
        },
        {
          id: 52,
          label: "52%",
          value: 0.52,
        },
        {
          id: 53,
          label: "53%",
          value: 0.53,
        },
        {
          id: 54,
          label: "54%",
          value: 0.54,
        },
        {
          id: 55,
          label: "55%",
          value: 0.55,
        },
        {
          id: 56,
          label: "56%",
          value: 0.56,
        },
        {
          id: 57,
          label: "57%",
          value: 0.57,
        },
        {
          id: 58,
          label: "58%",
          value: 0.58,
        },
        {
          id: 59,
          label: "59%",
          value: 0.59,
        },
        {
          id: 60,
          label: "60%",
          value: 0.6,
        },
        {
          id: 61,
          label: "61%",
          value: 0.61,
        },
        {
          id: 62,
          label: "62%",
          value: 0.62,
        },
        {
          id: 63,
          label: "63%",
          value: 0.63,
        },
        {
          id: 64,
          label: "64%",
          value: 0.64,
        },
        {
          id: 65,
          label: "65%",
          value: 0.65,
        },
        {
          id: 66,
          label: "66%",
          value: 0.66,
        },
        {
          id: 67,
          label: "67%",
          value: 0.67,
        },
        {
          id: 68,
          label: "68%",
          value: 0.68,
        },
        {
          id: 69,
          label: "69%",
          value: 0.69,
        },
        {
          id: 70,
          label: "70%",
          value: 0.7,
        },
        {
          id: 71,
          label: "71%",
          value: 0.71,
        },
        {
          id: 72,
          label: "72%",
          value: 0.72,
        },
        {
          id: 73,
          label: "73%",
          value: 0.73,
        },
        {
          id: 74,
          label: "74%",
          value: 0.74,
        },
        {
          id: 75,
          label: "75%",
          value: 0.75,
        },
        {
          id: 76,
          label: "76%",
          value: 0.76,
        },
        {
          id: 77,
          label: "77%",
          value: 0.77,
        },
        {
          id: 78,
          label: "78%",
          value: 0.78,
        },
        {
          id: 79,
          label: "79%",
          value: 0.79,
        },
        {
          id: 80,
          label: "80%",
          value: 0.8,
        },
        {
          id: 81,
          label: "81%",
          value: 0.81,
        },
        {
          id: 82,
          label: "82%",
          value: 0.82,
        },
        {
          id: 83,
          label: "83%",
          value: 0.83,
        },
        {
          id: 84,
          label: "84%",
          value: 0.84,
        },
        {
          id: 85,
          label: "85%",
          value: 0.85,
        },
        {
          id: 86,
          label: "86%",
          value: 0.86,
        },
        {
          id: 87,
          label: "87%",
          value: 0.87,
        },
        {
          id: 88,
          label: "88%",
          value: 0.88,
        },
        {
          id: 89,
          label: "89%",
          value: 0.89,
        },
        {
          id: 90,
          label: "90%",
          value: 0.9,
        },
        {
          id: 91,
          label: "91%",
          value: 0.91,
        },
        {
          id: 92,
          label: "92%",
          value: 0.92,
        },
        {
          id: 93,
          label: "93%",
          value: 0.93,
        },
        {
          id: 94,
          label: "94%",
          value: 0.94,
        },
        {
          id: 95,
          label: "95%",
          value: 0.95,
        },
        {
          id: 96,
          label: "96%",
          value: 0.96,
        },
        {
          id: 97,
          label: "97%",
          value: 0.97,
        },
        {
          id: 98,
          label: "98%",
          value: 0.98,
        },
        {
          id: 99,
          label: "99%",
          value: 0.99,
        },
        {
          id: 100,
          label: "100%",
          value: 1,
        },
      ],
    };
  },
  mounted() {},
  computed: {},
  methods: {
    openDialog(e, key) {
      this.key = key;
      this.resetForm("");
      let dic = {
        edit: "编辑",
        add: "新增",
      };
      this.title = dic[key];
      key == "edit" && this.HttpQueryTaletnDatil({ dicId: e.Id });
      if (key == "add") {
        this.formData = {
          TalentName: "",
          TalentCode: "",
          Type: "",
          TalentType: 4, //1:积分人才认定，2:层次人才认定
        };
        this.tableData_backup = [
          {
            Text: "",
            Score: "",
            Remark: "",
          },
        ];
        this.tableData = JSON.parse(JSON.stringify(this.tableData_backup));
        console.log("tableData", this.tableData);
      }
      this.isShowDialog = true;
    },
    resetForm(formName) {
      this.$refs.dicDialogFormRef && this.$refs.dicDialogFormRef.resetFields();
    },
    onCancel() {
      this.isShowDialog = false;
    },
    addRow(row) {
      let item = this.tableData.find((o) => !o.Text || !o.Value);
      if (item) {
        this.$message.error("请检查必选项是否填写完整");
        return;
      }
      this.tableData.push({
        Text: "",
        Score: "",
        Remark: "",
      });
    },
    delRow(row, index) {
      this.tableData.splice(index, 1);
    },
    selectChange(e) {
      this.tableData = JSON.parse(JSON.stringify(this.tableData_backup));
    },
    handleAvatarSuccess(res, file) {
      this.formData.Picture = res.response.Url;
    },
    beforeAvatarUpload(file) {
      const isImage = file.type.includes("image");
      const isLt4M = file.size / 1024 / 1024 < 10;
      if (!isImage) {
        this.$message.error("上传头像图片只能是图片格式!");
      }
      // if (!isLt4M) {
      //   this.$message.error("上传图片大小不能超过 10MB!");
      // }
      // return isImage && isLt4M;
      return isImage;
    },
    onSubmit() {
      this.btnLoading = true;
      let that = this;
      this.$refs.dicDialogFormRef.validate((valid) => {
        this.btnLoading = false;
        if (valid) {
          that.submit();
        } else {
          console.log("error submit!!", valid);
          return false;
        }
      });
    },
    submit() {
      let param = JSON.parse(JSON.stringify(this.formData));
      let item = this.tableData.find((o) => !o.Text || !o.Value);
      if (item && this.formData.Type == 1) {
        this.$message.error("请检查必选项是否填写完整");
        return;
      }
      Boolean(param.Weight) &&
        param.Weight.sort() &&
        (param.Weight = param.Weight.join(","));
      let details = this.formData.Type == "1" ? this.tableData : null;
      if (details) {
        details.forEach((o) => {
          o.TalentDicId = this.formData.Id;
        });
      }
      param.Details = details;

      this.key == "add" && this.HttpAddTalentDic(param);
      this.key == "edit" && this.HttpUpdateTalentDic(param);
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 【注意】一定要用 Object.seal() 否则会报错
    },
    async HttpQueryTaletnDatil(param) {
      this.isLoading = true;
      const response = await GetTalentTaletnDatil(param);
      this.isLoading = false;
      let res = response.data;
      if (res.status == 200) {
        let raw = res.response || {};
        let Children = raw.Children || [];
        if (raw.Weight) {
          let valueList = raw.Weight.split(",");
          raw.Weight = valueList.map((o) => o * 1);
        }
        this.tableData_backup = JSON.parse(JSON.stringify(Children));
        this.tableData = JSON.parse(JSON.stringify(Children));

        this.formData = raw;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    async HttpUpdateTalentDic(param) {
      this.btnLoading = true;
      const response = await UpdateTalentDic(param);
      this.btnLoading = false;
      let res = response.data;
      if (res.status == 200) {
        this.isShowDialog = false;
        this.$emit("refresh");
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    async HttpAddTalentDic(param) {
      this.btnLoading = true;
      const response = await AddTalentDic(param);
      this.btnLoading = false;
      let res = response.data;
      if (res.status == 200) {
        this.isShowDialog = false;
        this.$emit("refresh");
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
  },
};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style>
.center {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
